import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const { Button, Image, ImageButton, AbsolutePane, Tooltip } = MojitoPresentation.Components;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { lacksValues } = MojitoCore.Base.objUtils;

export default class BetslipButtonView extends UIViewImplementation {
    renderFreeBetsIcon() {
        return (
            <AbsolutePane
                config={this.config.freebetsIconContainer}
                class="ta-FreebetsIconContainer"
            >
                <Image config={this.config.freebetsIcon} class="ta-freebetIcon" />
            </AbsolutePane>
        );
    }

    render() {
        const { isHighlighted, isLoading, showImage, showOveraskImage } = this.props;
        if (showImage || showOveraskImage) {
            const imageButtonConfig = showOveraskImage
                ? this.style.overaskImageButton
                : this.config.imageButton;
            return (
                <ImageButton
                    class="ta-ImageBetslipButton"
                    config={imageButtonConfig}
                    onClick={this.props.onClick}
                />
            );
        }
        const buttonStyle = isHighlighted ? this.style.highlightedButton : this.config.button;
        return (
            <Button
                onClick={this.props.onClick}
                disabled={this.props.disabled}
                class="ta-BetslipButton notranslate"
                config={buttonStyle}
            >
                {this.props.children}
                {this.props.showFreebetsTip && (
                    <Tooltip
                        config={this.config.betslipTip}
                        text={this.resolveString('$BETSLIP_BUTTON.FREEBETS_TIP')}
                        onClose={this.props.onCloseFreebetsTip}
                        class="ta-FreebetsTip"
                    />
                )}
                {this.props.showFreebetsIcon && this.renderFreeBetsIcon()}
                {isLoading
                    ? this.resolveString('$BETSLIP_BUTTON.LOADING')
                    : this.props.betslipItemsCount}
            </Button>
        );
    }
}

BetslipButtonView.getStyle = (config, mode, merge) => {
    const highlightedButton = lacksValues(config.style.highlighted)
        ? config.button
        : merge(config.button, { style: { base: config.style.highlighted } });

    return {
        highlightedButton,
        overaskImageButton: merge(config.imageButton, config.overaskImageButton),
    };
};
